import Vue from 'vue'
import LoadingOverlay from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

Vue.use(LoadingOverlay, { color: "#134270", loader: "bars", width: 110, height: 90 })

Vue.component('LoadingOverlay', LoadingOverlay)